import script from "./EnrollStudentLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrollStudentLogin.vue?vue&type=script&setup=true&lang=js"

import "./EnrollStudentLogin.vue?vue&type=style&index=0&id=54d6917f&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d6917f"]])

export default __exports__